'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBoxContext', ['$controller', 'TimeService', 'Session', function ($controller, TimeService, Session) {
      return {
        templateUrl: 'views/directives/notes/saNoteQueryBoxContext.html',
        restrict: 'A',
        link: function (scope) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          scope.dropdownChoices = [
            {
              label: 'Today\'s Notes',
              callback: function() {
                scope.dropdownState = scope.dropdownChoices[0];
                var twx = TimeService.getDayTwixFromDate(new Date());
                baseCtrl.setQuery({
                  obj: 'date',
                  obj_id: null,
                  dates: {
                    start: twx.start,
                    end: twx.end
                  },
                  custom: false
                });
              }
            }, {
              label: 'Created by Me',
              callback: function() {
                scope.dropdownState = scope.dropdownChoices[1];
                baseCtrl.setQuery({
                  created_by: Session.getCurrentUserId(),
                  dates: {
                    start: null,
                    end: null
                  },
                  custom: false
                });
              }
            }, {
              label: 'Replied to by Me',
              callback: function() {
                scope.dropdownState = scope.dropdownChoices[2];
                baseCtrl.setQuery({
                  created_by: Session.getCurrentUserId(),
                  replies_only: true,
                  dates: {
                    start: null,
                    end: null
                  },
                  custom: false
                });
              }
            }, {
                label: 'About Me',
                callback: function() {
                  scope.dropdownState = scope.dropdownChoices[3];
                  baseCtrl.setQuery({
                    obj: 'User',
                    obj_id: Session.getCurrentUserId(),
                    dates: {
                      start: null,
                      end: null
                    },
                    custom: false
                  });
                }
            }
          ];
          scope.dropdownState = scope.dropdownChoices[0];

          scope.isCustom = false;
          function render(query) {
            if (query.custom) {
              scope.isCustom = true;
            } else {
              scope.isCustom = false;
            }
          }

          // Base ctrl
          baseCtrl.initialize('QueryBoxContext', scope.managementId);
          baseCtrl.setRenderCallback(render);
          baseCtrl.updateMyself();

          scope.$on('$destroy', function() {
            baseCtrl.uninitialize();
            baseCtrl = undefined;
          });
        }
      }
    }]);
